import { connect } from "react-redux";
import SurveyResult from "models/SurveyResult";
import AdditionResult from "models/AdditionResult";
import AttrResult from "models/AttrResult";

import AnswerResult from "components/answer/AnswerResult";

import history from "utils/history";
import storage from "utils/storage";
import { answerLoginURL } from "utils/formatter";
import api from "api";

import { setAuthErrorType } from "redux/modules/answer/answerLogin";
import {
  // attr edit dialog
  setAttrResult,
  openAttrEditDialog,
  closeAttrEditDialog,
  selectAttrItem,
  // basic edit dialog
  setBasicResult,
  openBasicEditDialog,
  closeBasicEditDialog,
  selectBasicItem,
  // addition edit dialog
  setAdditionResult,
  openAdditionEditDialog,
  closeAdditionEditDialog,
  selectAdditionItem,
  // 自由記入
  changeFreeCommentText,
  changeIsEditFreeCommnet1,
  changeIsEditFreeCommnet2
} from "redux/modules/answer/answerResult";

import {
  openConfirmDialog,
  closeConfirmDialog
} from "redux/modules/confirmDialog";
import { openErrorDialog } from "redux/modules/errorDialog";
import { openMessageDialog } from "redux/modules/messageDialog";

const mapStateToProps = state => ({
  answerResult: state.answerResult,
  answerAttribute: state.answerAttribute,
  answerHeader: state.answerHeader,
  answerOther: state.answerOther
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  showErrorDialog: () => {
    dispatch(openErrorDialog(new Error("authError")));
  },
  handleCompleteBtn: (answerResult, answerToken) => () => {
    const dialogData = {
      title: "確認",
      contentText: "回答結果を送信してアンケートを終了します。よろしいですか？\n注意：アンケート終了後にブラウザの「戻る」ボタンは押さないでください",
      btnLabel: "はい",
      handleClick: () => {
        dispatch(closeConfirmDialog());

        let surveyResult = new SurveyResult();
        const {
          attrResult,
          basicResult,
          additionResult,
          locale,
          loginDt,
          freeComment1,
          freeComment2
        } = answerResult;

        // 基本設問をセット
        Object.entries(basicResult).forEach(arr => {
          surveyResult = surveyResult.set(`q${arr[0]}`, arr[1].num);
        });

        // 属性をセット
        const attrResults = Object.entries(attrResult).map(arr => {
          const { surveyAttr, attrItem } = arr[1];
          return new AttrResult({
            surveyAttrId: surveyAttr.id,
            attrItemId: attrItem.id
          });
        });

        // 追加設問をセット
        const additionResults = Object.entries(additionResult).map(arr => {
          const { addition, choice } = arr[1];
          return new AdditionResult({
            additionId: addition.id,
            additionChoiceId: choice.id
          });
        });

        // 実施言語
        surveyResult = surveyResult.set("localeId", locale.id);

        // 実施日時
        surveyResult = surveyResult.set("loginDt", loginDt);

        // 自由記入
        surveyResult = surveyResult
          .set("freeComment1", freeComment1)
          .set("freeComment2", freeComment2);

        const params = {
          urlToken: storage.getUrlToken(),
          id: storage.getSurveyId(),
          answerToken,
          result: {
            surveyResult: surveyResult.toJS(),
            attrResults: attrResults.map(ar => ar.toJS()),
            additionResults: additionResults.map(ar => ar.toJS())
          }
        };

        api
          .post("/result", params)
          .then(res => {
            if (res.invalidStatusError) {
              dispatch(setAuthErrorType("canNotAnswer"));
              history.push(answerLoginURL(), ownProps);
            } else {
              history.push("/complete", ownProps);
            }
          })
          .catch(error => dispatch(openErrorDialog(error)));
      }
    };

    dispatch(openConfirmDialog(dialogData));
  },
  handlePrevBtn: () => {
    setTimeout(() => ownProps.history.goBack());
  },
  // attr edit doalog
  openAttrEditDialog: surveyAttr => () => {
    dispatch(openAttrEditDialog(surveyAttr));
  },
  selectAttrItem: item => {
    dispatch(selectAttrItem(item));
  },
  submitAttrDialog: (surveyAttr, attrItem) => () => {
    dispatch(setAttrResult(surveyAttr, attrItem));
    dispatch(closeAttrEditDialog());
  },
  closeAttrEditDialog: () => {
    dispatch(closeAttrEditDialog());
  },
  // basic edit doalog
  openBasicEditDialog: question => () => {
    dispatch(openBasicEditDialog(question));
  },
  selectBasicItem: num => () => {
    dispatch(selectBasicItem(num));
  },
  submitBasicDialog: (question, num) => () => {
    dispatch(setBasicResult(question, num));
    dispatch(closeBasicEditDialog());
  },
  closeBasicEditDialog: () => {
    dispatch(closeBasicEditDialog());
  },
  // addition edit doalog
  openAdditionEditDialog: addition => () => {
    dispatch(openAdditionEditDialog(addition));
  },
  selectAdditionItem: choice => () => {
    dispatch(selectAdditionItem(choice));
  },
  submitAdditionDialog: (addition, choice) => () => {
    dispatch(setAdditionResult(addition, choice));
    dispatch(closeAdditionEditDialog());
  },
  closeAdditionEditDialog: () => {
    dispatch(closeAdditionEditDialog());
  },
  // 自由記入
  onChangeFreeCommentText1: text => {
    dispatch(changeFreeCommentText("freeComment1", text));
  },
  onChangeFreeCommentText2: text => {
    dispatch(changeFreeCommentText("freeComment2", text));
  },
  onChangeIsEditFreeCommnet1: (flg, text) => {
    if (text.length <= 400) {
      dispatch(changeIsEditFreeCommnet1(flg));
    } else {
      dispatch(
        openMessageDialog(
          `コメントは400字以内で入力してください。(現在${text.length}文字)`
        )
      );
    }
  },
  onChangeIsEditFreeCommnet2: (flg, text) => {
    if (text.length <= 400) {
      dispatch(changeIsEditFreeCommnet2(flg));
    } else {
      dispatch(
        openMessageDialog(
          `コメントは400字以内で入力してください。(現在${text.length}文字)`
        )
      );
    }
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(AnswerResult);



// WEBPACK FOOTER //
// ./src/containers/answer/AnswerResultContainer.js